/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Sdt_DescInputs */

const vi_station_voice_ph_sdt_desc = /** @type {(inputs: Station_Voice_Ph_Sdt_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại khách (đọc từng chữ số)`)
};

/**

* @param {Station_Voice_Ph_Sdt_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_sdt_desc = /** @type {((inputs?: Station_Voice_Ph_Sdt_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Sdt_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_sdt_desc(inputs)
});